import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const BallotBoxIcon: React.FC<OneColorIconProps> = ({ size = 24, color = 'black', className }) => {
  const hex = getHexColor(color)
  return (
    <svg
      data-testid="chat-bubble-outline"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 21.5C4.45 21.5 3.97917 21.3039 3.5875 20.9118C3.19583 20.5196 3 20.0482 3 19.4975V14.9419L5.75 11.8131L7.175 13.2399L5.175 15.4926H18.825L16.875 13.2899L18.3 11.8632L21 14.9419V19.4975C21 20.0482 20.8042 20.5196 20.4125 20.9118C20.0208 21.3039 19.55 21.5 19 21.5H5ZM5 19.4975H19V17.4951H5V19.4975ZM10.625 13.8656L7.1 10.3363C6.71667 9.95248 6.52917 9.48107 6.5375 8.92205C6.54583 8.36303 6.74167 7.89161 7.125 7.50781L12.025 2.60178C12.4083 2.21798 12.8833 2.01773 13.45 2.00104C14.0167 1.98436 14.4917 2.16791 14.875 2.55172L18.4 6.08106C18.7833 6.46486 18.9833 6.9321 19 7.48278C19.0167 8.03345 18.8333 8.50069 18.45 8.8845L13.45 13.8907C13.0667 14.2745 12.5958 14.4622 12.0375 14.4538C11.4792 14.4455 11.0083 14.2494 10.625 13.8656ZM17 7.50781L13.475 3.97847L8.525 8.93456L12.05 12.4639L17 7.50781Z"
        fill={hex}
      />
    </svg>
  )
}
